// extracted by mini-css-extract-plugin
export var entityChip = "_sl-0";
export var entityChipMissing = "_sl-1";